const OPPORTUNITY_CAROUSEL_MOBILE_MARGIN = -192;
const OPPORTUNITY_CAROUSEL_DESKTOP_MARGIN = -192;
const TWEEN_FACTOR_BASE = 0.52;

export {
    OPPORTUNITY_CAROUSEL_MOBILE_MARGIN,
    OPPORTUNITY_CAROUSEL_DESKTOP_MARGIN,
    TWEEN_FACTOR_BASE,
};
